<template>
  <el-dialog
    v-model="dialogFormVisible"
    :title="title"
    width="500px"
    @close="close"
  >
    <el-form ref="form" label-width="80px" :model="form" :rules="rules">
      <el-form-item label="名称" prop="title">
        <el-input v-model.trim="form.title" />
      </el-form-item>
      <el-form-item label="排序" prop="order">
        <el-input-number v-model.trim="form.order" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
  import { addFeedbackTag, editFeedbackTag } from '@/api/settings'

  export default {
    name: 'SettingsFeedbackTagEdit',
    emits: ['fetch-data'],
    data() {
      return {
        form: {
          feedbackTagId: '',
          title: '',
          order: 0,
        },
        rules: {
          feedbackTagId: [],
          title: [{ required: true, trigger: 'blur', message: '请填写名称' }],
          order: [],
        },
        title: '',
        dialogFormVisible: false,
      }
    },
    methods: {
      showEdit(row) {
        if (!row) {
          this.title = '添加'
        } else {
          this.title = '编辑'
          this.form = Object.assign(
            {},
            {
              feedbackTagId: row.feedbackTagId,
              title: row.title,
              order: row.basic.order,
            }
          )
        }
        this.dialogFormVisible = true
      },
      close() {
        this.$refs['form'].resetFields()
        this.form = this.$options.data().form
        this.dialogFormVisible = false
      },
      save() {
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            await (this.form.feedbackTagId
              ? editFeedbackTag(this.form)
              : addFeedbackTag(this.form))
            this.$baseMessage(
              this.form.feedbackTagId ? '修改标签成功' : '新增标签成功',
              'success',
              false,
              'vab-hey-message-success'
            )
            this.$emit('fetch-data')
            this.close()
          } else {
            return false
          }
        })
      },
    },
  }
</script>
